export default {"src":"/_next/static/media/KR.437e783c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};